export default __webpack_public_path__ + "static/media/cover.6d4e0c87.jpg";